var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { env } from "../auth/config/env";
import { styles } from "../styles";
import { unsafeSVG } from "lit/directives/unsafe-svg.js";
import { icons } from "../util/icons";
import { invokeCoreApi } from "../util/coreApiClient";
import { Translatable } from "@bender/localization";
import { BenderLocalizationLoader } from "../util/bender-translations";
let NotificationBell = class NotificationBell extends LitElement {
    constructor() {
        super(...arguments);
        // set property for number of notifications
        this.notificationCount = 0;
        // set property for notifications data
        this.notificationData = [];
        // state to control when click on bell and display some text
        this.showDropdown = false;
        // state to check if there are notifications
        this.isAnyNotificationReceived = false;
        this.isTranslationDataLoaded = false;
        this.localizationLoader = new BenderLocalizationLoader();
        // call API for num of notifications, if there are none, number wont be displayed
        this.getNotificationsNumber = async () => {
            const data = await invokeCoreApi(env.frontDoorUrl, "/notificationsCount", "get", {});
            return data.count;
        };
        this.getNotificationsData = async () => {
            const data = await invokeCoreApi(env.frontDoorUrl, "/notifications", "get", {});
            return data.notifications;
        };
        // Send PUT to API to acknowledge notifications
        this.handleAcknowledge = async (notificationId) => {
            this.notificationData = this.notificationData.filter(el => el.id !== notificationId);
            this.notificationCount--;
            await invokeCoreApi(env.frontDoorUrl, "/notifications/{notificationId}/acknowledgements", "post", {
                parameters: {
                    notificationId
                }
            });
            this.checkNotificationCount();
        };
    }
    connectedCallback() {
        super.connectedCallback();
        void this.localizationLoader.loadLocalizations().then(localizationServiceAdapter => {
            this.translator = localizationServiceAdapter;
            this.isTranslationDataLoaded = true;
        });
        this.timerInterval = setInterval(() => {
            void this.loadNotifications(); /* This void is to make lint work */
        }, 60000);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        clearInterval(this.timerInterval);
    }
    // the table content
    render() {
        const createNote = (data) => {
            var _a;
            return html ` <tr>
        <td class="severity">${unsafeSVG(icons[data.severity])}</td>
        <td>
          ${data.content}
          <a
            href=${(_a = data.link) !== null && _a !== void 0 ? _a : ""}
            ?hidden=${data.link === undefined}
            target="_blank"
            class="icon-link"
          >
            ${unsafeSVG(icons.link)}
          </a>
          <div class="notification-category"><span>${data.category}</span></div>
        </td>
        <td>
          <button
            class="btn btn-default btn-sm"
            type="button"
            @click=${async () => {
                await this.handleAcknowledge(data.id);
            }}
          >
            ${this.isTranslationDataLoaded ? Translatable.translate("key:Tools_Common_Okay", this.translator) : "Ok"}
          </button>
        </td>
      </tr>`;
        };
        // the button and popup container
        return html `
      <div class="notification-container">
        <button
          type="button"
          class="header-btn"
          @click=${() => {
            this.handleNotificationClick();
        }}
        >
          ${unsafeSVG(icons.bell)}
          <span
            ?hidden=${!this.isAnyNotificationReceived}
            class="notification-number"
            >${this.notificationCount}</span
          >
        </button>

        <div
          class="dropdown-content"
          ?hidden=${!this.showDropdown}
        >
          <div ?hidden=${this.isAnyNotificationReceived}>
            <div class="empty-state">
              ${this.isTranslationDataLoaded
            ? Translatable.translate("key:no_notifications_for_user", this.translator)
            : "You currently have no notifications"}
            </div>
          </div>

          <table
            class="notification-table"
            ?hidden=${!this.isAnyNotificationReceived}
          >
            <tbody>
              ${this.notificationData.filter(el => !el.acknowledged).map(createNote)}
            </tbody>
          </table>
        </div>
      </div>
      <div
        ?hidden=${!this.showDropdown}
        @click=${() => {
            this.showDropdown = false;
        }}
        class="dropdown-background"
      ></div>
    `;
    }
    // Function to execute notifications data and number
    async loadNotifications() {
        await window.benderAuth.getToken();
        this.notificationData = await this.getNotificationsData();
        this.notificationCount = await this.getNotificationsNumber();
        this.checkNotificationCount();
    }
    // Set variable value true/false to display notification data table
    handleNotificationClick() {
        this.toggleDropdown();
    }
    toggleDropdown() {
        this.showDropdown = !this.showDropdown;
    }
    // Checks notification_count to hide number/table if user has no notifications at all
    checkNotificationCount() {
        this.notificationCount > 0 ? (this.isAnyNotificationReceived = true) : (this.isAnyNotificationReceived = false);
    }
};
// import general styles
NotificationBell.styles = styles;
__decorate([
    property({ type: Number })
], NotificationBell.prototype, "notificationCount", void 0);
__decorate([
    property({ type: Array })
], NotificationBell.prototype, "notificationData", void 0);
__decorate([
    property({ attribute: false })
], NotificationBell.prototype, "timerInterval", void 0);
__decorate([
    state()
], NotificationBell.prototype, "translator", void 0);
__decorate([
    state()
], NotificationBell.prototype, "showDropdown", void 0);
__decorate([
    state()
], NotificationBell.prototype, "isAnyNotificationReceived", void 0);
__decorate([
    state()
], NotificationBell.prototype, "isTranslationDataLoaded", void 0);
NotificationBell = __decorate([
    customElement("bender-notification-bell")
], NotificationBell);
export { NotificationBell };
//# sourceMappingURL=notification-bell.js.map